import memoize from 'lodash/memoize';
import { decodeHTML } from 'entities';
// eslint-disable-next-line no-script-url
const DISALLOWED_PROTOCOLS = [
    'javascript:'
];
const ALLOWED_PROTOCOLS = [
    'http:',
    'https:',
    'mailto:',
    'tel:',
    'vscode:',
    'swish:'
];
const pollutionPattern = `\\b(?:constructor|__defineGetter__|__defineSetter__|hasOwnProperty|__lookupGetter__|__lookupSetter__|isPrototypeOf|propertyIsEnumerable|toString|valueOf|__proto__|toLocaleString)\\b`;
const pollutionRegex = new RegExp(pollutionPattern, 'i');
/**
 * Retrieves the protocol from the URL
 * @example
 * ```
 * getUrlProtocol("https://amp.corp.stripe.com"); // returns 'https:'
 * ```
 * @param url
 */ const getUrlProtocol = (url)=>{
    if (typeof url === 'string') {
        try {
            const u = new URL(url);
            return u.protocol;
        } catch (e) {
            return;
        }
    }
    return url.protocol;
};
const isUrlProtocolAllowed = (url, allowedProtocols = ALLOWED_PROTOCOLS)=>{
    const protocol = getUrlProtocol(url);
    if (!protocol) {
        return true;
    }
    return allowedProtocols.includes(protocol) && !DISALLOWED_PROTOCOLS.includes(protocol);
};
const parseUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch (e) {
        return undefined;
    }
};
const tryParseURL = (u)=>{
    if (typeof u === 'string') {
        var _parseUrl;
        const resolved = (_parseUrl = parseUrl(u)) !== null && _parseUrl !== void 0 ? _parseUrl : // e.g. when u = /path
        parseUrl(u, // In SSR context, location is not defined which causes this to throw an error.
        // We only use the value to run the sanity check on the URL and we don't return the value,
        // so it is safe to use a static URL if location is undefined. Using localhost in this case
        typeof location !== 'undefined' ? location.origin : 'http://localhost');
        return resolved;
    }
    return undefined;
};
const containsProtoKeywords = (u)=>{
    const parsedUrl = tryParseURL(u);
    if (!parsedUrl) {
        return false;
    }
    const urlParts = [
        parsedUrl.pathname,
        parsedUrl.search,
        parsedUrl.hash
    ];
    return urlParts.some((part)=>pollutionRegex.test(part));
};
export const isSafeUrl = memoize((u, options)=>{
    var _isSafeUrl_cache;
    // Prevent memory leaks by clearing the cache periodically
    if (((_isSafeUrl_cache = isSafeUrl.cache) === null || _isSafeUrl_cache === void 0 ? void 0 : _isSafeUrl_cache.size) === 1000) {
        var _isSafeUrl_cache_clear, _isSafeUrl_cache1;
        (_isSafeUrl_cache_clear = (_isSafeUrl_cache1 = isSafeUrl.cache).clear) === null || _isSafeUrl_cache_clear === void 0 ? void 0 : _isSafeUrl_cache_clear.call(_isSafeUrl_cache1);
    }
    const decodedUrl = typeof u === 'string' ? decodeHTML(u) : u;
    var _options_allowedProtocols;
    if (!isUrlProtocolAllowed(decodedUrl, [
        ...ALLOWED_PROTOCOLS,
        ...(_options_allowedProtocols = options === null || options === void 0 ? void 0 : options.allowedProtocols) !== null && _options_allowedProtocols !== void 0 ? _options_allowedProtocols : []
    ])) {
        // eslint-disable-next-line no-console
        console.warn(`[safe-links] redirect (${u}) blocked. URL has invalid protocol`);
        return false;
    }
    if (containsProtoKeywords(decodedUrl)) {
        // eslint-disable-next-line no-console
        console.warn(`[safe-links] redirect (${u}) blocked. URL contains proto keywords`);
        return false;
    }
    return true;
}, (url, options)=>JSON.stringify([
        url,
        typeof location !== 'undefined',
        options
    ]));
export const getTargetWindow = (options)=>{
    switch(options === null || options === void 0 ? void 0 : options.target){
        case 'top':
            return window.top || window;
        case 'parent':
            return window.parent || window;
        default:
            // 'self' and undefined
            return window;
    }
};

//# sourceMappingURL=utils.js.map